var account = "Račun";
var accountSettings = "Postavke računa";
var charging = "Punjenje";
var contactInfo = "Kontaktni podaci";
var dashboard = "Izbornik";
var home = "Početna";
var myProducts = "Moji proizvodi";
var orderHistory = "Pregled narudžbe";
var paymentMethod = "Način plaćanja";
var profileSettings = "Postavke profila";
var referAndEarn = "Preporučite i zaradite";
var signOut = "Odjava";
var hr_HR = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, hr_HR as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
